import { defineAction } from '~/prix'
import llmChatUpdateAction from './llmChatUpdate.action.json' assert { type: 'json' }
import { z } from 'zod'

const llmChatUpdateDefinition = defineAction({
  ...llmChatUpdateAction,

  // input: z.object({
  //   id: z.number(),
  //   title: z.string().nullish(),
  //   isFixed: z.boolean().nullish(),
  //   archivedAt: dateOrIsoString().nullish(),
  // }),
  // output: z.object({}),
  input: z.object({
    id: z.number(),
    title: z.string().nullish(),
    isFixed: z.boolean().nullish(),
    archivedAt: z.string().nullish(),
  }),
  output: z.object({}),
})

export default llmChatUpdateDefinition
